
















import { Component, Prop, Ref } from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import { RawLocation } from 'vue-router'

@Component
export default class StickyButton extends RouterHelper {
  @Ref('stickyBtn') stickyBtn!: HTMLElement
  private showStickyBtnBorder: boolean = true
  private observer!: IntersectionObserver

  mounted () {
    this.observeStickyElement()
  }

  destroyed () {
    this.observer.disconnect()
  }

  /**
   * 设置sticky元素的border
   */
  private observeStickyElement () {
    this.observer = new IntersectionObserver(
      (entries) => {
        this.showStickyBtnBorder = entries[0].intersectionRatio < 1
      },
      { root: document.querySelector('.el-main'), threshold: [1] }
      // intersectionRatio 可见比例, 完全可见为 1
      // threshold: [1] 当元素100%可见时(在这里是拉到底部), 触发回调函数, 页面初始化的时候会触发一次
    )
    this.observer.observe(this.stickyBtn)
  }
}
